@if (isClosed) {
<app-icon-plus
  [width]="width"
  [height]="height"
  [color]="color"
></app-icon-plus>
} @else {
<app-icon-minus
  [width]="width"
  [height]="height"
  [color]="color"
></app-icon-minus>
}
